export const NAVBAR_HEIGHT = {
  xs: 72,
  md: 112,
} as const;
